import styled from 'styled-components';
import { H1, H2, SectionParent } from '../../../components/StyledComponents';
import Slide from 'react-reveal/Slide';
import React from 'react';
import lottie, { AnimationItem } from 'lottie-web';
import BringBuy from '../../lottieAnimations/Bring_Buy_Build.json';

const SectionOne = styled(SectionParent)`
  background-repeat: no-repeat;
  background-color: #ffffff;
  border-bottom: solid 1px #a5b2d3;
  padding-top: 3rem !important;
  padding-bottom: 5rem;
  background-size: contain;
  @media (max-width: 1680px) and (min-width: 1440px) {
    padding-bottom: 3rem;
  }
  @media (max-width: 1440px) and (min-width: 768px) {
    padding-bottom: 5rem;
  }
  @media (max-width: 768px) {
    padding-top: 8rem !important;
  }
  @media (max-width: 520px) {
    padding-top: 2rem !important;
    padding-bottom: 5rem !important;
  }
  width: 100%;
  display: grid;
`;

const SectionItemContainer = styled.div`
  grid-template-columns: repeat(2, 1fr);
  padding-left: 5rem;
  display: grid;
  @media (max-width: 768px) {
    padding-left: 0rem;
  }
`;

const HeroTitle = styled(H1)`
  /* margin-left: 2.5rem; */
  color: #151828;
  text-align: left;
  font-family: 'Nunito Sans', sans-serif;
  font-weight: bold;
  @media (min-width: 1440px) {
    font-size: 28px !important;
  }
  @media (max-width: 768px) {
    margin-left: 0rem;
    text-align: center;
  }
`;

const GridRight = styled.div`
  grid-column: span 1;
  padding-right: 8rem;
  /* padding-left: 3rem; */
  margin-top: 3rem;
  align-content: center;
  display: grid;
  @media (max-width: 1100px) {
    margin-top: 7rem;
  }
  @media (max-width: 768px) {
    grid-column: span 2;
    padding-right: 0rem;
    margin-top: 0rem;
    padding-left: 0rem;
    min-height: 15rem;
  }
`;
const GridLeft = styled.div`
  grid-column: span 1;
  position: relative;
  @media (max-width: 1100px) {
    padding-left: 0;
  }
  @media (max-width: 768px) {
    grid-column: span 2;
    padding-left: 0;
    max-width: 20rem;
    justify-self: center;
  }
`;

const HeroSubTitle = styled.div`
  padding-top: 2rem;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  text-align: left;
  font-stretch: normal;
  line-height: 1.64;
  letter-spacing: normal;
  color: #151828;
  @media (max-width: 768px) {
    text-align: center;
    margin-left: 0rem;
    font-size: 16px;
  }

  @media (max-width: 520px) {
    text-align: center;
    padding-top: 0.5rem;
    margin-bottom: -1rem;
    margin-left: 0;
  }
`;

export default class KioskSecondPage extends React.Component<any, any> {
  animation?: AnimationItem;

  constructor(props: any) {
    super(props);
    this.animation = undefined;
  }

  loadAnimation = () => {
    this.animation = lottie.loadAnimation({
      name: 'animation-kiosk',
      container: document.getElementById('lottie-animation-build')!,
      loop: false,
      renderer: 'svg',
      autoplay: true,
      animationData: BringBuy,
    });
  };

  render() {
    return (
      <div>
        <SectionOne id="section-one-kiosk">
          <SectionItemContainer>
            <GridLeft>
              <Slide bottom={true} onReveal={this.loadAnimation}>
                <GridLeft id="lottie-animation-build" />
              </Slide>
            </GridLeft>
            <GridRight>
              <HeroTitle>
                We’re Compatible with ALL Modern Android Hardware.
              </HeroTitle>
              <HeroSubTitle style={{ paddingTop: '1rem' }}>
                Can you bring your own digital signage hardware? Absolutely!
                Esper is compatible with your existing Android investments. When
                you’re ready to expand your digital signage fleet, we have
                solutions to help you scale. Esper offers a wide selection of
                hardware including Lenovo and Shuttle Computing models, and
                single-board computer boards from Khadas, Odroid, and more.{' '}
                <br />
                <br />
                You can even build your own custom SBC for dedicated signage via
                Esper’s partnership with MediaTek. <br />
                <br />
                Esper makes device enrollment easy, whether you decide to buy it
                or build it. You can even ship your hardware straight to the
                point of deployment ready to automatically be configured via the
                cloud upon first boot up.
                <br />
                <br />
              </HeroSubTitle>
            </GridRight>
          </SectionItemContainer>
        </SectionOne>
      </div>
    );
  }
}
